<template>
  <div>
    <v-card class="shadow rounded-lg">
      <v-card-title>
        <div>
          <v-text-field outlined
                        v-model="search"
                        dense
                        rounded
                        prepend-inner-icon="mdi-magnify"
                        hide-details
                        placeholder="Recherche..."></v-text-field>
        </div>
        <v-spacer/>
        <v-btn color="gifty" depressed dark @click="create(null)">
          <v-icon left>mdi-plus</v-icon>
          Ajouter un rôle
        </v-btn>
      </v-card-title>
      <v-divider/>
      <v-card-text>
        <v-data-table :search="search"
                      :loading="isLoading"
                      :headers="headers"
                      :items="roles"
                      class="rounded-lg table-border"
        >
          <template v-slot:item.id="{ item }">
            <span class="font-weight-bold">#{{ item.id }}</span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn icon color="gifty" @click="create(item)">
              <v-icon>mdi-pencil-outline</v-icon>
            </v-btn>
            <v-btn icon color="gifty" @click="remove(item.id)">
              <v-icon>mdi-delete-outline</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog width="600" v-model="dialog">
      <v-card>
        <v-card-title>
          {{ form.id ? "Modifier un rôle" : "Ajouter un rôle" }}
          <v-spacer/>
          <v-icon @click="dialog = false">mdi-close</v-icon>
        </v-card-title>
        <v-divider/>
        <div>
          <form @submit.prevent="save">
            <v-card-text class="pa-8">
              <v-text-field outlined
                            label="Nom *"
                            hide-details="auto"
                            dense
                            :error-messages="errors.name"
                            v-model="form.name"></v-text-field>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
              <v-spacer/>
              <v-btn :loading="btnLoading"
                     color="primary"
                     depressed
                     type="submit">
                <v-icon left>mdi-content-save</v-icon>
                Enregistrer
              </v-btn>
            </v-card-actions>
          </form>
        </div>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
  data() {
    return {
      id: null,
      isLoading: false,
      dialog: false,
      search: null,
      btnLoading: false,
      form: {},
      errors: {},
      roles: [],
      headers: [
        {text: 'Rôle', value: 'name'},
        {text: 'ID', value: 'id'},
        {
          text: 'Actions',
          sortable: false,
          value: 'actions',
        },
      ],
    }
  },
  methods: {
    create(item = null) {
      this.dialog = true
      this.form = {
        id: item ? item.id : null,
        name: item ? item.name : null,
      }
    },
    save() {
      this.errors = {};
      let url = this.form.id ? '/v1/users-managment/roles/update' : "/v1/users-managment/roles/store";

      this.btnLoading = true;

      HTTP.post(url, this.form).then(() => {
        this.btnLoading = false;
        this.$successMessage = "Cette page a été enregistrée avec succès.";
        this.getData();
        if (this.form.id) {
          this.dialog = false
        } else {
          this.form = {}
        }
      }).catch(err => {
        this.btnLoading = false;
        this.errors = err.response.data.errors;
        this.$errorMessage = "Une erreur s'est produite veuillez corriger.";
        console.log(err);
      });
    },
    getData() {
      this.isLoading = true;
      HTTP.get("v1/users-managment/roles")
          .then((res) => {
            this.roles = res.data.data;
            this.isLoading = false;
          })
          .catch((e) => {
            this.isLoading = false;
            console.log(e);
          });
    },
    remove(id) {
      this.id = id;
      this.$confirm_dialog = true;
    },
    deleteItem() {
      this.isLoading = true;
      HTTP.post("v1/users-managment/roles/delete", {
        id: this.id,
      }).then(() => {
        this.isLoading = false;
        let i = this.roles.findIndex((el) => el.id === this.id);
        this.$delete(this.roles, i);
        this.id = null;
        this.$successMessage = "Cet élément a été supprimé avec succès.";
      }).catch((err) => {
        this.isLoading = false;
        console.log(err);
      });
    },
  },
  created() {
    this.getData()
  },
  watch: {
    $is_confirm: function (el) {
      if (el) {
        this.deleteItem();
        this.$is_confirm = false;
      }
    }
  }
}
</script>

<style scoped>

</style>